import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UpdateRegistrationContactPage } from '../update-registration-contact/update-registration-contact';
import { UpdateRegistrationAddress1Page } from '../update-registration-address1/update-registration-address1';
import { UpdateRegistrationPersonalPage } from '../update-registration-personal/update-registration-personal';
import { UpdateRegistrationParentPage } from '../update-registration-parent/update-registration-parent';
import { UpdateRegistrationDocumentPage } from '../update-registration-document/update-registration-document';
import { UpdateRegistrationAffiliatedPage } from '../update-registration-affiliated/update-registration-affiliated';
import { UpdateRegistrationPasswordPage } from '../update-registration-password/update-registration-password';

import { AuthProvider } from '../../providers/auth/auth';
import { ValidatorProvider } from '../../providers/validator/validator';

/**
 * Generated class for the UpdateRegistrationPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration',
  templateUrl: 'update-registration.html',
})
export class UpdateRegistrationPage {

  private user: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider
  ) {
    this.user = this.authProvider.getUser();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationPage');
  }

  isAddressComplete() {
    return (!this.validatorProvider.isEmpty(this.user.address)) &&
      (!this.validatorProvider.isEmpty(this.user.addressNumber)) &&
      (!this.validatorProvider.isEmpty(this.user.addressCountry)) &&
      (!this.validatorProvider.isEmpty(this.user.addressCity)) &&
      (!this.validatorProvider.isEmpty(this.user.addressState)) &&
      (!this.validatorProvider.isEmpty(this.user.addressZip));
  }

  isPersonalComplete() {
    return (this.user.genre !== null) &&
      (this.user.nationality !== null) &&
      (!this.validatorProvider.isEmpty(this.user.birthPlace));
  }

  isParentComplete() {
    return (!this.validatorProvider.isEmpty(this.user.motherName));
  }

  isDocumentComplete() {
    return (this.user.documentKind !== null) &&
      (!this.validatorProvider.isEmpty(this.user.documentCode)) &&
      (this.user.scholarity !== null);
  }

  isAffiliatedComplete() {
    return (this.user.affiliatedFederalCode !== null) &&
      (!this.validatorProvider.isEmpty(this.user.affiliatedName));
      //&& (this.user.courseCode !== null);
  }

  goToUpdateContactPage() {
    this.navCtrl.push(UpdateRegistrationContactPage, {}, {
      animation: 'ios-transition'
    });
  }

  goToUpdateAddressPage() {
    this.navCtrl.push(UpdateRegistrationAddress1Page, {}, {
      animation: 'ios-transition'
    });
  }

  goToUpdatePersonalDataPage() {
    this.navCtrl.push(UpdateRegistrationPersonalPage, {}, {
      animation: 'ios-transition'
    });
  }

  goToUpdateParentPage() {
    this.navCtrl.push(UpdateRegistrationParentPage, {}, {
      animation: 'ios-transition'
    });
  }

  goToUpdateDocumentPage() {
    this.navCtrl.push(UpdateRegistrationDocumentPage, {}, {
      animation: 'ios-transition'
    });
  }

  goToUpdateAffiliatedPage() {
    this.navCtrl.push(UpdateRegistrationAffiliatedPage, {}, {
      animation: 'ios-transition'
    });
  }

  goChangePasswordPage() {
    this.navCtrl.push(UpdateRegistrationPasswordPage, {}, {
      animation: 'ios-transition'
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration/update-registration.ts